import { createSelector } from '@ngrx/store';
import { currentLocationState } from '../root';

export const isCurrentLocationValid = createSelector(
    currentLocationState,
    currentLocation => Boolean(currentLocation.validation?.hasSucceeded)
);
